export function updateCost(data) {
    let { updateCostRequest, updateCostError, updateCostResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'update_cost',
        this.createBundle('update_cost', { cost: data }, this.POST, updateCostRequest, updateCostResult, updateCostError)
    )
}
